import { gql, useMutation } from '@apollo/client'
import { BodyText, Button, Heading, Modal } from '@farol-ds/react'
import { OabTransferringFormFieldsInput } from '@jusbrasil-web/shared-apollo-client/__generated__/types'
import { Image } from '@jusbrasil-web/shared-next-image'
import { useEffect } from 'react'

import { useValidateOabModalContext } from '../../context'
import envelopeSvg from '../../images/envelope.svg'
import styles from '../steps.module.scss'
import {
  SendOabTransferringEmailMutation,
  SendOabTransferringEmailMutationVariables,
} from './__generated__/email-sent.graphql'

export const SendOabTransferringEmail = gql`
  mutation SendOabTransferringEmail($input: SendOabTransferringEmailInput!) {
    sendOabTransferringEmail(input: $input) {
      success
    }
  }
`

export function EmailSent() {
  const { setOpenToFalse, emailConflicted, getServerDataValues } = useValidateOabModalContext()
  const [sendEmail, { data, error }] = useMutation<
    SendOabTransferringEmailMutation,
    SendOabTransferringEmailMutationVariables
  >(SendOabTransferringEmail)

  useEffect(() => {
    const { birthDate, cpf, oab, oabType, oabUf, oabUfLabel, origin } = getServerDataValues()
    const formFields: OabTransferringFormFieldsInput = {
      birthDate,
      cpf,
      oab,
      oabType,
      oabUf,
      oabUfLabel,
      origin,
    }
    sendEmail({
      variables: {
        input: {
          currentUrl: window.location.href,
          formFields,
        },
      },
      // Catch the error to avoid unhandled promise rejection, error is handled in the useEffect below
    }).catch(() => undefined)
  }, [getServerDataValues, sendEmail])

  useEffect(() => {
    // TODO: should we show something? @felipemsantana
    if (data?.sendOabTransferringEmail?.success === false) {
      console.error('Failed to send OAB transferring email')
    } else if (error) {
      console.error('Error sending OAB transferring email:', error)
    }
  }, [data?.sendOabTransferringEmail?.success, error])

  return (
    <>
      <Modal.IconClose />
      <Modal.Body className={styles.infoModalBody}>
        <Image src={envelopeSvg} width={140} height={140} loading="lazy" alt="" />
        <Heading className={styles['infoModalBody-heading']}>E-mail de verificação enviado</Heading>
        <BodyText className={styles['infoModalBody-bodyText']}>
          Acesse o e-mail que enviamos para <strong>{emailConflicted}</strong> para cadastrar a OAB
          à conta atual.
        </BodyText>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={setOpenToFalse} kind="primary">
          Concluir
        </Button>
        <Button kind="secondary" asChild>
          <a
            href="https://suporte.jusbrasil.com.br/hc/pt-br/requests/new"
            target="_blank"
            rel="noopener noreferrer"
          >
            Contatar suporte
          </a>
        </Button>
      </Modal.Footer>
    </>
  )
}
